module.exports = __webpack_public_path__ + "img/gorse.cb870a69.png";